<template>
  <div>
    <v-divider/>
    <v-list-tile :style="active">
      <v-list-tile-avatar class="list-avatar-icon" :style="activeText">
        <div class="circle" :style="dataSetGroupColour">
          <span v-if="!isFirstElement">{{dataSet.logic}}</span>
        </div>
      </v-list-tile-avatar>
      <v-list-tile-title class="pl-2">
        <h5 class="truncate">{{dataSet.description}}</h5>
      </v-list-tile-title>
      <v-list-tile-content></v-list-tile-content>
      <v-list-tile-action>
        <v-menu top left offset-y ref="templateItemAction">
          <v-btn :id="templateActionBtnId" :aria-label="templateActionBtnId" slot="activator" icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list role="menu" class="py-0">
            <v-list-tile @click="clickDelete">
              <v-list-tile-title :id="templateActionDeleteId" :aria-label="templateActionDeleteId">
                <v-icon class="pr-2">delete</v-icon>
                {{$t('admin.alerts.new.data_sets.delete')}}
              </v-list-tile-title>
            </v-list-tile>

            <v-list-tile @click="clickVisibility">
              <v-list-tile-title :id="templateActionVisibilityId" :aria-label="templateActionVisibilityId">
                <div v-if="!visible">
                  <v-icon class="pr-2">visibility_off</v-icon>
                  {{$t('admin.alerts.new.data_sets.show')}}
                </div>
                <div v-else>
                  <v-icon class="pr-2">visibility</v-icon>
                  {{$t('admin.alerts.new.data_sets.hide')}}
                </div>
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-list-tile-action>
    </v-list-tile>
  </div>
</template>
<script>
  import { SET_DATA_SET_ITEM_VISIBILITY } from '../../../store/mutation-types'
  import Colors from '../../../mixins/Colors'
  import { getDataSetDescription } from '../../../HelperMethods'
  import { DELETE_DATA_SET_ITEM } from '../../../store/action-types'

  export default {
    name: 'alert-data-set-item',
    mixins: [Colors],
    data () {
      return {
        activeWidth: '5px',
        activeTransition: 'all 0.3s ease-in-out'
      }
    },
    props: {
      dataSet: {
        type: Object
      },
      dataSetKey: {
        type: Number
      },
      panelColour: {
        type: Object
      },
      firstElement: {
        type: Number
      }
    },
    methods: {
      clickVisibility () {
        this.$store.commit(SET_DATA_SET_ITEM_VISIBILITY, {key: this.dataSetKey, visible: !this.visible})
      },
      clickDelete () {
        let payload = {
          id: this.dataSet.id,
          toBeDeleted: true
        }
        this.$store.dispatch(DELETE_DATA_SET_ITEM, payload)
      }
    },
    computed: {
      templateActionBtnId () {
        return `data-set-action-${this.dataSetKey}`
      },
      templateActionDeleteId () {
        return `data-set-delete-btn-${this.dataSetKey}`
      },
      templateActionVisibilityId () {
        return `data-set-visibility-btn-${this.dataSetKey}`
      },
      translateDescription () {
        let key = getDataSetDescription(this.dataSet)
        return this.$t(key.text, {x: key.x, y: key.y, yy: this.$t(key.yy), z: key.z})
      },
      visible () {
        return this.dataSet.visible
      },
      active () {
        if (this.visible) {
          return {
            borderLeft: `solid ${this.activeWidth} ${this.panelColour.backgroundColor}`,
            transition: this.activeTransition
          }
        }
      },
      activeText () {
        if (this.visible) {
          return {
            marginLeft: `-${this.activeWidth}`,
            transition: this.activeTransition
          }
        }
      },
      dataSetGroupColour () {
        if (this.dataSet.logicColour !== null) {
          return `border-color: ${this.logicColours[this.dataSet.logicColour]}`
        }
        return `border-color: transparent`
      },
      isFirstElement () {
        return this.dataSet.id === this.firstElement
      }
    }
  }
</script>

<style scoped>
  .circle {
    border-radius: 100%;
    width: 2.5rem;
    height: 2.5rem;
    text-align: center;
    padding-top: 6px;
    border: 2px solid;
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertDataSetItem.vue